import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule } from '../shared/shared.module';

import { CompanyListsComponent }                  from './company-lists.component';
import { CompanyListsCustomerSourcesComponent }   from './company-lists.customer-sources.component';
import { CompanyListsPaymentMethodsComponent }    from './company-lists.payment-methods.component';
import { CompanyListsProductCategoriesComponent } from './company-lists.product-categories.component';
import { CompanyListsProductGroupsComponent }     from './company-lists.product-groups.component';
import { CompanyListsTemplateComponent }          from './company-lists.template.component';
import { CompanyListsTemplatesComponent }         from './company-lists.templates.component';

@NgModule({
  declarations: [
    CompanyListsComponent,
    CompanyListsCustomerSourcesComponent,
    CompanyListsPaymentMethodsComponent,
    CompanyListsProductCategoriesComponent,
    CompanyListsProductGroupsComponent,
    CompanyListsTemplateComponent,
    CompanyListsTemplatesComponent
  ],
  entryComponents: [
    CompanyListsComponent,
    CompanyListsTemplateComponent,
    CompanyListsTemplatesComponent
  ],
  imports: [
    SharedModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class CompanyListsModule {}
